<template>
  <div class="CompanyCulture">
    <!-- 企业文化 -->
    <div class="box-culture wow fadeInUp animated">
      <RecruitTit cn="企业文化" en="CORPORATE CULTURES"></RecruitTit>
      <div class="cont">
        <img :src="item.imageUrl" v-for="(item,index) in resCultureList" :key="'box_culture'+index">
      </div>
    </div>
    <!-- 员工风采 -->
    <div class="box-staff wow fadeInUp animated">
      <RecruitTit cn="员工风采" en="STAFF PRESENCE"></RecruitTit>
      <div class="staffList clear">
        <div class="item-staff" v-for="(item, index) in resList" :key="index">
          <div class="box_img">
            <img
              :src="item.imageUrl"
              :large="item.imageUrl"
              preview="staffList"
              :preview-text="item.imageName"
              :alt="'staff' + index"
            />
          </div>

          <div class="box_info">
            <div class="b_title">{{ item.imageName }}</div>
            <!-- <div class="b_time">{{ item.time }}</div> -->
          </div>
        </div>
      </div>
      <div class="pagecon" v-if="total>8">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
          @size-change="getPage"
          @current-change="getPage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import RecruitTit from "../../components/common/recruitTit";
if (process.browser) {
  var { WOW } = require("wowjs");
}
export default {
  name:'CompanyCulture',
  data() {
    return {
      // staffList: [
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg16.jpg"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg16.jpg"),
      //     title: "2021第四季度安全应急演练",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg17.jpg"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg17.jpg"),
      //     title: "观看抗疫电影《中国医生》",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg18.jpg"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg18.jpg"),
      //     title:
      //       "守好防腐门•把好幸福关--梧州黄埔公司党支部开展廉政警示教育活动照片",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg19.jpg"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg19.jpg"),
      //     title: "梧州黄埔公司与北环路小学共同开展党建联盟活动与师生合影",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg20.jpg"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg20.jpg"),
      //     title: "梧州黄埔开展2021年新员工座谈会现场",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg21.jpg"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg21.jpg"),
      //     title:
      //       "梧州学院资源循环科学与工程专业学生到梧州黄埔实习现场照片车间现场见习",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg22.jpg"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg22.jpg"),
      //     title:
      //       "梧州学院资源循环科学与工程专业学生到梧州黄埔实习现场照片观看入厂安全教育视频",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg23.jpg"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg23.jpg"),
      //     title:
      //       "梧州学院资源循环科学与工程专业学生到梧州黄埔实习现场照片实习合照",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg1.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg1-1.jpg"),
      //     title: "“黄埔化工杯“健步走活动",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg2.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg2-1.jpg"),
      //     title: "春节慰问",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg3.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg3-1.jpg"),
      //     title: "合唱队排练",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg4.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg4-1.jpg"),
      //     title: "莫枝礼在听机械的运转声音",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg5.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg5-1.jpg"),
      //     title: "莫枝礼在维修出故障的减速机",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg6.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg6-1.jpg"),
      //     title: "女职工开展“毛毛虫”活动",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg7.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg7-1.jpg"),
      //     title: "女职工开展烧烤活动",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg8.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg8-1.jpg"),
      //     title: "女职工开展珠行千里活动",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg9.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg9-1.jpg"),
      //     title: "女职工素质提升茶艺培训班",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg10.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg10-1.jpg"),
      //     title: "乒乓球比赛活动",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg11.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg11-1.jpg"),
      //     title: "气排球比赛活动",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg12.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg12-1.jpg"),
      //     title: "庆祝“三八妇女节”活动",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg13.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg13-1.jpg"),
      //     title: "员工才艺作品征集活动摄影作品评比",
      //     time: "2019-08-07",
      //   },
      //   {
      //     imgsrc: require("../../assets/images/company/CompanyCulture/staffImg14.png"),
      //     imgBigSrc: require("../../assets/images/company/CompanyCulture/staffImg14-1.jpg"),
      //     title: "员工才艺作品征集活动书法作品评比",
      //     time: "2019-08-07",
      //   },
      // ],
      resList: [],
      resCultureList: [],
      culturePageSize:1,
      total: 1, // 总数
      pageNo: 1, // 当前页
      pageSize: 8, // 每页显示条数
    };
  },
  mounted() {
    this.getStaffListList();
    this.getCultureList();
    if (process.browser) {
      new WOW({
        live: false,
        offset: 0,
      }).init();
    }
  },
  methods: {
    // 获取企业文化图片
    async getCultureList() {
      let res = await this.$request.getImageManageList({
        columnType: 15,
        pageSize:this.culturePageSize
      });
      // 图片增加相关域名
      res.rows.map((val, index) => {
        val.imageUrl = this.$store.state.baseUrl + val.imageUrl;
      });
      this.resCultureList = res.rows;
      // 大图预览功能重置刷新
      this.$previewRefresh();
    },
    // 获取员工风采图片
    async getStaffListList() {
      let res = await this.$request.getImageManageList({
        columnType: 10,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      this.total = res.total;
      // console.log(res.total)
      // 图片增加相关域名
      res.rows.map((val, index) => {
        val.imageUrl = this.$store.state.baseUrl + val.imageUrl;
      });
      this.resList = res.rows;
      // 大图预览功能重置刷新
      this.$previewRefresh();
    },
    async getPage(page) {
      // 获取第 page 页数据
      // console.log(page);
      this.pageNo = page;
      this.getStaffListList();
    },
  },
  components: { RecruitTit },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
.CompanyCulture {
  width: $contWidth;
  margin: 0 auto;
  .box-culture {
    padding: 2.08vw 0 0 0;
    .cont {
      margin-top: 1.56vw;
      width: $contWidth;
      // height: 16.88vw;
      position: relative;
      // background: url("../../assets/images/company/CompanyCulture/cultureBg.png")
      //   no-repeat;
      // background-size: 100%;
      img{
        display: block;
        width: 100%;
      }
    }

  }
  .box-staff {
    padding: 2.08vw 0 0 0;
    .staffList {
      padding: 2.08vw 0 0 0;
      .item-staff {
        float: left;
        width: 17.45vw;
        margin: 0 1.04vw 1.56vw 0;
        // cursor: pointer;
        &:nth-child(4n) {
          margin: 0;
        }
        &:hover .box_img {
          img {
            transform: scale(1.1, 1.1);
          }
        }
        .box_img {
          width: 17.45vw;
          height: 13.33vw;
          overflow: hidden;
          img {
            width: 100%;
            display: block;
            transition: 0.6s ease-in-out;
          }
        }

        .box_info {
          width: 17.45vw - 1.88vw;
          height: 3.54vw - 1.25vw - 1.04vw;
          padding: 0.63vw 0.94vw;
          background-color: #eeeeee;
          .b_title {
            font-size: 0.83vw;
            line-height: 1.25vw;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
          }
          .b_time {
            font-size: 0.73vw;
            line-height: 1.56vw;
            color: #666666;
          }
        }
      }
    }
    .pagecon {
      text-align: center;
      padding: 20px 0;
    }
  }
}
@media (min-width: 1920px) {
  .CompanyCulture {
    width: 1400px;
    margin: 0 auto;
    .box-culture {
      padding: 40px 0 0 0;
      .cont {
        margin-top: 30px;
        width: 1400px;
        // height: 324px;
        // background: url("../../assets/images/company/CompanyCulture/cultureBg.png")
        //   no-repeat;
        // background-size: auto 100%;
        img{
        display: block;
        width: 100%;
      }
      }
    }
    .box-staff {
      padding: 40px 0 0 0;
      position: relative;
      .staffList {
        padding: 40px 0 0 0;
        .item-staff {
          float: left;
          width: 335px;
          margin: 0 20px 30px 0;
          // cursor: pointer;
          &:nth-child(4n) {
            margin: 0;
          }
          &:hover .box_img {
            img {
              transform: scale(1.1, 1.1);
            }
          }
          .box_img {
            width: 335px;
            height: 256px;
            overflow: hidden;
            img {
              width: 100%;
              display: block;
              transition: 0.6s ease-in-out;
            }
          }

          .box_info {
            width: 335px - 36px;
            height: 68px - 24px - 20px;
            padding: 12px 18px;
            background-color: #eeeeee;
            .b_title {
              font-size: 16px;
              line-height: 24px;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: center;
            }
            .b_time {
              font-size: 14px;
              line-height: 30px;
              color: #666666;
            }
          }
        }
      }
    }
  }
}
.pagecon /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #83bb26;
  color: #fff;
}

.pagecon /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #83bb26;
}
</style>